module.exports = __webpack_public_path__ + "img/IconsetSmiles.3bb24c00.png";